import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../core/authentication/auth';
import { LoaderService } from '../../core/ui/loader';
import { AlertService } from '../../core/ui/alert';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-password-reset',
	imports: [CommonModule, ReactiveFormsModule, RouterModule, MatFormFieldModule, MatInputModule, MatButtonModule],
	templateUrl: './password-reset.html',
	styleUrl: './password-reset.css'
})
export class PasswordReset implements OnInit {
	passwordResetForm!: FormGroup;
	firebaseError: string | null = null;
	readonly isDev = !environment.production;

	constructor(private formBuilder: FormBuilder, private authService: AuthService, private router: Router, private loaderService: LoaderService, private alertService: AlertService) {}

	ngOnInit(): void {
		this.passwordResetForm = this.formBuilder.group({
			email: ['', [Validators.required, Validators.email]]
		});
	}

	get emailControl() {
		return this.passwordResetForm.get('email');
	}

	async onSubmit(): Promise<void> {
		this.passwordResetForm.markAllAsTouched();
		this.firebaseError = null;

		if(this.passwordResetForm.valid) {
			this.loaderService.show();

			const { email } = this.passwordResetForm.value;

			try {
				await this.authService.resetPassword(email);

				this.alertService.success('Hemos enviado las instrucciones para restablecer tu contraseña. Por favor, revisa tu bandeja de entrada (y también tu carpeta de spam).', 'Correo enviado');
				this.loaderService.hide();
				this.router.navigate(['/']);
			} catch (error: any) {
				switch (error.code) {
					case 'auth/invalid-email':
						this.firebaseError = 'El formato del correo electrónico es inválido.';
					break;
					case 'auth/too-many-requests':
						this.firebaseError = 'Has realizado demasiados intentos. Por favor, inténtalo de nuevo más tarde.';
					break;
					case 'auth/network-request-failed':
						this.firebaseError = 'Problemas de conexión. Por favor, verifica tu conexión a internet.';
					break;
					case 'auth/internal-error':
						this.firebaseError = 'Ha ocurrido un error interno. Por favor, inténtalo de nuevo.';
					break;
					default:
						this.firebaseError = 'Ocurrió un error inesperado al intentar restablecer la contraseña. Inténtalo de nuevo.';
					break;
				}

				this.alertService.error(this.firebaseError, 'Error');
				this.loaderService.hide();
			}
		}
	}
}
